function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import PropTypes from 'prop-types';
import Loader from '@domain-group/fe-co-loader';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import Footer from './footer';
import * as styles from './eu-user.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class EuUserPage extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "optedIn", () => {
      this.submitForm(true);
    });
    _defineProperty(this, "optedOut", () => {
      this.submitForm(false);
    });
    _defineProperty(this, "submitForm", hasOptedIn => {
      this.setState({
        isSubmitting: true
      });
      this.props.onOptIn(hasOptedIn).finally(() => this.setState({
        isSubmitting: false
      }));
    });
    this.state = {
      isSubmitting: false
    };
  }
  render() {
    return ___EmotionJSX("div", null, ___EmotionJSX("div", {
      css: styles.title
    }, "Want to hear from Allhomes?"), this.props.error.length > 0 && ___EmotionJSX("div", {
      css: styles.formSubmitError
    }, this.props.error[0].message), ___EmotionJSX("div", {
      css: styles.body
    }, "There are new laws aimed at giving you more control over your personal data. This means you'll need to let us know if you would like to receive emails from us like", ' ', ___EmotionJSX("span", {
      css: styles.bodyBold
    }, "property alerts, announcements, newsletters"), ' ', "or ", ___EmotionJSX("span", {
      css: styles.bodyBold
    }, "partner communications.")), ___EmotionJSX("div", {
      css: styles.footer
    }, "Opt-in now if you want to hear from (or continue hearing from) Allhomes."), ___EmotionJSX(Button, {
      css: styles.submitButton,
      onClick: this.optedIn,
      disabled: this.state.isSubmitting
    }, this.state.isSubmitting ? ___EmotionJSX(Loader, {
      css: styles.submitButtonLoader,
      dark: true,
      transparent: true,
      size: "mini"
    }) : 'Yes, opt me in'), ___EmotionJSX(Button, {
      css: styles.button,
      appearance: "ghost",
      onClick: this.optedOut,
      disabled: this.state.isSubmitting
    }, this.state.isSubmitting ? ___EmotionJSX(Loader, {
      css: styles.submitButtonLoader,
      dark: true,
      size: "mini"
    }) : 'No, unsubscribe me'), ___EmotionJSX(Footer, {
      onCloseModal: this.props.onCloseModalCallback
    }));
  }
}
EuUserPage.propTypes = {
  onOptIn: PropTypes.func,
  error: PropTypes.arrayOf(PropTypes.shape({
    message: PropTypes.string
  })),
  onCloseModalCallback: PropTypes.func.isRequired
};
EuUserPage.defaultProps = {
  onOptIn: () => Promise.resolve(),
  error: []
};
export default EuUserPage;